import React from 'react';
import CKEditor from 'ckeditor4-react';
import { Col, Container, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import cx from 'classnames';
import * as _ from 'lodash';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import * as moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { bindActionCreators } from 'redux';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
// import { CreatePost } from '../../admin';
import { BackStrip, Header } from '../../../common/layout';
import * as adminActions from '../../../store/admin';
import * as pagesActions from '../../../store/portal';
import { config } from '../../../config/config';
import { NotificationManager } from 'react-notifications';
import { DialogBox } from '../../../common/dialogbox/components';
import ContentHTML from './ContentHTML';
import AssessmentTasks from './AssessmentTasks';
import { utilService } from '../../../common/utils';
import { sortUnitsByStartDate } from '../helper/pagesHelper';

/**
 * LMS Page
 * Page componet is used to show pages which is created under admin tab
 * Page is showed based on incoming slug
 */
let dataList = []
class Pages extends React.Component {
  constructor(props) {
    super(props);
    // Handle input change event
    this.handleInputChange = this.handleInputChange.bind(this);
    // Handle editor change event
    this.onEditorChange = this.onEditorChange.bind(this);
    // Handle file upload req through CKE event
    this.onFileUploadReq = this.onFileUploadReq.bind(this);
    // Handle file upload res through CKE event
    this.onFileUploadRes = this.onFileUploadRes.bind(this);
    // Handle form saved event
    this.handleFormSaved = this.handleFormSaved.bind(this);
    // to update ordered page nav items
    this.handlePageNavDragEnd = this.handlePageNavDragEnd.bind(this);

    this.handleHTMLContent = this.handleHTMLContent.bind(this);

    // Handle page state
    this.state = {
      // current place object
      place: {},
      // Manage current active tab id
      tabId: 'default',
      // to show place title on banner
      placeTitle: '',
      // Manage edit title sucha as title, content etc
      editTitle: '',
      // save current tab's page details
      currentTabPageDetails: {
        title: '',
      },
      // To Manage delete google folder id
      modal_data: {
        show: false,
      },
      // To manage delete page
      deletePageModalData: {
        show: false,
      },
      // To hide/show add blog button
      addBlogEnabled: false,
      // To save current page details
      editPageData: {},
      // To manage page hiding progress flag
      pageHiding: false,
      // To manage page sowing progress flag
      pageShowing: false,
      // To manage current page progress
      pageHidingId: '',
      editing: '',
      // To manage back button
      backUrl: '/',
      // To disabled button
      isLoading: false,
      // To manage api progress
      isSaving: false,
      // To manage page creating fields
      pageCreating: {
        adding: false,
        type: 'Static Page',
      },
      publishDateUpdateData: false,
      deletingPage: false,
      pageData: {},
      editblogData: {},
      // To manage edit icon hide/show
      editIconEnable: false,
      // to maintain ordered page nav items
      pageNavs: [],
      // maintain on order change process
      pageOrderChange: false,
      isResize: false,
      // Error handling object
      errors: {},
    };
    // To manage iframe view type
    this.iframeFileView = 'list';
    // Page array with all pages except which are hidden or deleted
    this.filteredPages = [];
    // Page array which are not allowed to drag
    this.dragDisabledPages = [];
    // Page array which are allowed to drag
    this.draggablePages = [];
    // To show static page on LMS Page
    this.staticPages = [
      {
        pageUid: 'create-static-page',
        title: 'NEW PAGE',
        slug: 'new-page',
        buttonName: '+ Add new page',
        pageType: 'Static Page',
      },
      {
        pageUid: 'create-document-page',
        title: 'New Files Pages',
        slug: 'new-files-pages',
        buttonName: '+ Add file page',
        pageType: 'Documents',
      },
    ];
    // To manage file repo page type
    this.fileRepoPageTypeName = 'Documents';
    // To show field names
    this.fieldNames = {
      place: { name: 'placeUid', errorKey: 'place' },
      pageType: { name: 'pagetypeUid', errorKey: 'pagetype' },
      title: { name: 'title', errorKey: 'title' },
      landingPage: { name: 'landing_page' },
      navigation: { name: 'navigation' },
      contentHtml: { name: 'content_html', errorKey: 'content_html' },
      googleFolderID: {
        name: 'google_drive_url',
        type: 'file_view_type',
        errorKey: 'googleFolder',
      },
      description: { name: 'description', errorKey: 'description' },
    };
    // to manage CKE flag
    this.CKE = null;
    this.taskPageData = {
      pageUid: 'taskPage',
      pagetype_pagetype: 'Task Page',
      [this.fieldNames.title.name]: 'Assessment Tasks',
      pageTitle: 'Assessment Tasks',
    };
    // this.classroomsPageData = {
    //   pageUid: 'classroomsPage',
    //   slug: 'classrooms-page',
    //   pagetype_pagetype: 'Classrooms Page',
    //   [this.fieldNames.title.name]: 'Classrooms',
    //   pageTitle: 'Classrooms',
    // };
    this.yearTrio = [
      {
        year: moment().subtract(1, 'year').year(),
      },
      { year: moment().year(), default: true },
      { year: moment().add(1, 'year').year() },
    ];
  }

  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    this.props.clearPages(); // clear old page data on initial render
    // fetch place based on slug
    // fetch places
    this.props.fetchPlaces({
      token: this.props.token,
      params: '?slug=' + this.props.match.params.slug,
    });
    // get page types
    this.props.fetchPageTypes({
      token: this.props.token,
      params: '',
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth < 768) {
        this.setState({ isResize: true })
      } else {
        this.setState({ isResize: false })
      }
    })
  }

  /**
   * After saving blog form show success notification
   * @param {*} dataFromCreatePost
   */
  handleFormSaved(dataFromCreatePost) {
    if (dataFromCreatePost.isSaved) {
      NotificationManager.success(
        'Success message',
        'Blog saved successfully.'
      );
      this.setState({
        addBlogEnabled: false,
      });
    }
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    // check user is carer or not? if carer, user can not see classroom page
    let is_user_carer = false;
    if (this.props.user) {
      if (this.props.user.is_carer && this.props.user.type === 'affiliate') {
        is_user_carer = true;
      }
    }
    if (nextProps.pages !== this.props.pages) {
      if (nextProps.pages.length > 0) {
        // find landing page details
        let pages = nextProps.pages;
        // make landing page should be first on the list
        pages.forEach((item, index) => {
          if (item.landing_page) {
            pages.splice(index, 1);
            pages.unshift(item);
          }
        });
        let currentTabPageDetails = {};
        let tabId = 'default';
        if (
          this.props.match.params['pageSlug'] &&
          this.state.tabId === 'default'
        ) {
          currentTabPageDetails = pages[0];
          tabId = pages[0]['pageUid'];
        } else if (this.state.tabId !== 'default') {
          let id = this.state.tabId;
          let pageDetails = _.find(pages, function (o) {
            return o.pageUid === id;
          });
          currentTabPageDetails = pageDetails;
          tabId = this.state.tabId;
        } else {
          let landingPageDetails = _.find(pages, function (o) {
            return o.landing_page === true;
          });
          currentTabPageDetails = landingPageDetails;
        }
        this.setState({
          placeTitle: pages[0]['place_place'],
          currentTabPageDetails: currentTabPageDetails,
          tabId: tabId,
        });

        this.dragDisabledPages = pages.filter((page) => {
          if (page[this.fieldNames.landingPage.name]) {
            return page;
          }
          return false;
        });

        if (this.props.match.params.slug !== 'boarding-house') {
          this.dragDisabledPages.splice(1, 0, this.taskPageData);
        }

        // carer user can not see classroom page
        // if (
        //   !is_user_carer &&
        //   this.props.match.params.slug !== 'boarding-house'
        // ) {
        //   this.dragDisabledPages.splice(2, 0, this.classroomsPageData);
        // }

        // START of new code
        const pageHasSortOrder = [];
        const nonDraggablePages = [];
        const tempPages = [];
        const pagesToHide = [];
        pages.forEach((page) => {
          if (page.is_deleted) {
            // hide deleted pages
            pagesToHide.push(page);
          } else if ('landing_page' in page && page.landing_page) {
            // static pages are not draggable
            nonDraggablePages.push(page);
          } else if (page.pageHide && !this.state.editIconEnable) {
            pagesToHide.push(page);
          } else {
            // draggable pages
            'sort_order' in page
              ? pageHasSortOrder.push(page)
              : tempPages.push(page);
          }
        });

        // Sort the pageHasSortOrder array.
        let newSorted = new Array(pageHasSortOrder.length + tempPages.length);

        let outOfBounds = [];

        pageHasSortOrder.forEach((page) => {
          // check if out of bounds
          if (
            page.sort_order < newSorted.length &&
            !newSorted[page.sort_order]
          ) {
            newSorted[page.sort_order] = page;
          } else {
            outOfBounds.push(page);
          }
        });

        // Fill the empty spaces in newSorted from tempPages
        for (let i = 0; i < newSorted.length; i++) {
          if (newSorted[i]) {
            // Ignore if element already present.
          } else {
            const elementToAdd = tempPages.pop();
            if (elementToAdd) {
              newSorted[i] = elementToAdd;
              // set new sort_order
              newSorted[i]['sort_order'] = i;
            }
          }
        }

        if (outOfBounds.length > 0) {
          // Sort all pages that go out of bounds of newSorted.
          outOfBounds = outOfBounds.sort((a, b) => a.sort_order - b.sort_order);
        }

        // Remove all the empty spaces from the newSorted.
        newSorted = newSorted.filter((page) => page);
        this.filteredPages = [
          ...nonDraggablePages,
          ...newSorted,
          ...outOfBounds,
        ];
        if (this.props.match.params.slug !== 'boarding-house') {
          this.filteredPages.splice(1, 0, this.taskPageData);
        }

        // carer user can not see classroom page
        // if (
        //   !is_user_carer &&
        //   this.props.match.params.slug !== 'boarding-house'
        // ) {
        //   this.filteredPages.splice(2, 0, this.classroomsPageData);
        // }
        // Append outOfBounds to newSorted which will be assigned to navPages
        this.setState({
          pageNavs: [...newSorted, ...outOfBounds],
        });
      }
    }
    if (this.props.places !== nextProps.places) {
      if (nextProps.places.length > 0 && !this.state.place['placeUid']) {
        let place = nextProps.places[0];
        let editors = nextProps.places[0]['editors'];

        // set backurl if klaUid is exist in place object
        let backUrl = '/';
        if (place['klaUid']) {
          backUrl = '/key-learning-area/' + place['klaUid'];
        }

        // if (place['klaUid'] && place['key_learning_area']) {
        //   if (this.props.match.params.slug !== 'boarding-house') {
        //     this.dragDisabledPages.splice(1, 0, this.taskPageData);
        //   }
        //   if (
        //     !is_user_carer &&
        //     this.props.match.params.slug !== 'boarding-house'
        //   ) {
        //     this.dragDisabledPages.splice(2, 0, this.classroomsPageData);
        //   }
        // }
        let editIconEnable = editors.includes(this.props.user.username);

        // if (this.props.match.params.slug == 'boarding-house') {
        //   editIconEnable = false;
        // }

        this.setState({
          place: place,
          backUrl: backUrl,
          editIconEnable: editIconEnable,
        });
        let params = '?place=' + place['placeUid'];
        if (this.props.match.params['pageSlug']) {
          params = params + '&page_slug=' + this.props.match.params['pageSlug'];
        } else {
          // params = params + '&navigation=' + true;
        }
        // fetch pages
        this.props.fetchPages({
          token: this.props.token,
          params: params,
        });

        if (place.hasOwnProperty('place_id')) {
          // get course units
          this.props.getUnits({
            token: this.props.token,
            params: '?course_id=' + place.place_id,
          });

          if (this.props.user) {
            if (!is_user_carer) {
              //get course classrooms by course ID
              this.props.getCourseClassrooms({
                token: this.props.token,
                params: '?course_id=' + place.place_id,
              });
            }
          }
        }
      }
    }
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs in state and props
   * @param {*} prevProps
   */

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.pageActionLoading && !this.props.pageActionLoading) {
      if (this.state.isSaving) {
        this.setState(
          {
            errors: {},
            editTitle: '',
            editing: '',
            isLoading: false,
            isSaving: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Edited successfully.'
            );
          }
        );
      }
      // On page Hiding update state fields
      if (this.state.pageHiding) {
        this.setState(
          {
            errors: {},
            editTitle: '',
            editing: '',
            pageHiding: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Page hide successfully.'
            );
          }
        );
      }

      // On page showing update state fields
      if (this.state.pageShowing) {
        this.setState(
          {
            errors: {},
            editTitle: '',
            editing: '',
            pageShowing: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Page show successfully.'
            );
          }
        );
      }

      // On page published date update state fields
      if (this.state.publishDateUpdateData) {
        this.setState(
          {
            publishDateUpdateData: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Page published date changed successfully.'
            );
          }
        );
      }

      // On page published date update state fields
      if (this.state.deletingPage) {
        this.setState(
          {
            deletingPage: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Page deleted successfully.'
            );
          }
        );
      }

      if (this.state.pageCreating['adding']) {
        this.setState(
          {
            ...this.state,
            pageCreating: {
              ...this.state.pageCreating,
              adding: false,
              type: 'Static Page',
            },
            errors: {},
            editTitle: '',
            editing: '',
            isLoading: false,
            isSaving: false,
          },
          function () {
            NotificationManager.success(
              'Success message',
              'Page added successfully.'
            );
          }
        );
      }
      if (this.state.pageOrderChange) {
        this.setState({ pageOrderChange: false });
        NotificationManager.success(
          'Success message',
          'Page order changed successfully.'
        );
      }
    }
  }

  handleHTMLContent(e) {
    console.log(">>>>>>>>>>>>>>>>>>>>>")

  }
  activeTabIndex(id, e) {
    e.preventDefault();
    let pageDetails = _.find(this.props.pages, function (o) {
      return o.pageUid === id;
    });
    let thisObj = this;
    this.setState(
      {
        currentTabPageDetails: {
          title: '',
        },
      },
      function () {
        thisObj.setState({
          addBlogEnabled: false,
          editTitle: '',
          tabId: id,
          currentTabPageDetails: pageDetails,
        });
      }
    );
  }

  /**
   * Handle input change event
   * @param {*} e
   */
  handleInputChange(e) {
    const { name, value } = e.target;
    let fields = this.state.editPageData;
    if (name === 'title') {
      let slug = value.trim();
      slug = slug.toLowerCase();
      slug = slug.split(' ');
      slug = slug.filter((e) => e !== '');
      slug = slug.join('-');
      fields['slug'] = slug;
    }
    fields[name] = value;
    this.setState({
      fields,
    });
  }

  /**
   * Set content of editor
   * @param {*} e
   */

  onEditorChange(e) {
    let fields = this.state.editPageData;
    fields[this.fieldNames.contentHtml.name] = e.editor.getData();
    // this.content_html = e.editor.getData();
    // this.setState({
    //   fields,
    // });
  }

  handlePageNavDragEnd(result) {
    if (result.destination === null) {
      return false;
    }
    const newPageSort = Array.from(this.state.pageNavs);

    const [reorderedItem] = newPageSort.splice(result.source.index, 1);
    newPageSort.splice(result.destination.index, 0, reorderedItem);

    // this.setState({ pageNavs: newPageSort });

    const updatedSortData = newPageSort.map((page, index) => ({
      pageUid: page.pageUid,
      sort_order: index,
    }));

    this.props.updatePageSortOrder({
      token: this.props.token,
      data: { sortData: updatedSortData },
      params: '?update_sort_order=' + true,
    });
    this.setState({ pageOrderChange: true });
  }

  clickonEditIcon(type, e) {
    e.preventDefault();
    let pageData = this.state.currentTabPageDetails;
    if (type === 'Documents') {
      if (!pageData['file_view_type']) {
        pageData['file_view_type'] = 'list';
      }
    }
    let thisObj = this;
    this.setState(
      {
        editPageData: {},
      },
      function () {
        thisObj.setState({
          editTitle: type,
          editPageData: Object.assign({}, pageData),
        });
      }
    );
  }

  // onEditTitle(e) {
  //   e.preventDefault();
  // }

  /**
   * Summary. Function used to send server request to upload image.
   *
   * @param {*} e  ckeditor upload event
   */
  onFileUploadReq(e) {
    let xhr = e.data.fileLoader.xhr;
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.props.token);
    xhr.send(
      JSON.stringify({
        base64ImageUrl: e.data.fileLoader.data.split(',')[1],
      })
    );
    e.stop();
    e.cancel();
  }

  /**
   * Summary. Function used to get response of upload editor image from server.
   * @param {*} e upload response event
   */
  onFileUploadRes(e) {
    e.stop();
    let data = e.data;
    let xhr = data.fileLoader.xhr;
    let response = xhr.responseText.split('|');
    if (response[1]) {
      // An error occurred during upload.
      data.message = response[1];
      e.cancel();
    } else {
      let parse_response = JSON.parse(response[0].toString());
      data.url = parse_response['responceObject']['records']['url'];
    }
  }

  onCancel(e) {
    e.preventDefault();
    /*if (this.CKE) {
                  for (let key in this.CKE.instances) {
                    this.CKE.instances[key].destroy();
                  }
                }*/
    this.setState({
      editTitle: '',
    });
  }

  /**
   * Validate form field before sumbmitting
   */
  validateForm() {
    let fields = this.state.editPageData;
    let errors = {};
    let formIsValid = true;
    if (!fields[this.fieldNames.title.name]) {
      formIsValid = false;
      errors[this.fieldNames.title.errorKey] = '*Please enter title.';
    }
    // if (
    //   !fields[this.fieldNames.contentHtml.name] &&
    //   fields.pagetype_pagetype !== this.fileRepoPageTypeName
    // ) {
    //   formIsValid = false;
    //   errors[this.fieldNames.contentHtml.name] = '*Please enter content';
    // }
    // if (
    //   !fields[this.fieldNames.googleFolderID.name] &&
    //   fields.pagetype_pagetype === this.fileRepoPageTypeName
    // ) {
    //   formIsValid = false;
    //   errors[this.fieldNames.googleFolderID.errorKey] =
    //     '*Please enter Google Drive folder ID.';
    // }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  handleCloseModal() {
    this.setState({
      ...this.state,
      modal_data: {
        ...this.state.modal_data,
        show: false,
      },
      deletePageModalData: {
        ...this.state.deletePageModalData,
        show: false,
      },
    });
  }

  initiateDeleteFolderID(pageUid, e) {
    e.preventDefault();
    if (pageUid) {
      this.setState({
        modal_data: {
          show: true,
          data: {
            heading: 'Unlink Google Drive folder',
            body: 'Are you sure you want to unlink this Google Drive folder?',
            rowId: pageUid,
          },
        },
      });
    }
  }

  handleDeleteFolderID(pageUid) {
    const currentTabData = { ...this.state.currentTabPageDetails };
    const isCurrentTabDataMatch = currentTabData.pageUid === pageUid;
    let updatedData = {};
    if (isCurrentTabDataMatch) {
      // if tab data match then ignore finding it from all the pages
      currentTabData[this.fieldNames.googleFolderID.name] = '';
      updatedData = { ...currentTabData };
    } else {
      updatedData = {
        ...this.props.pages.find((page) => page.pageUid === pageUid),
      };
    }
    this.setState({
      modal_data: {
        ...this.state.modal_data,
        show: false,
      },
      isLoading: true,
    });
    this.props.updatePage({
      token: this.props.token,
      data: { pageData: updatedData },
    });
  }

  /**
   * Hide/show page
   * Editors can only hide and show the page.After hiding people can not see that page until editor revisible it
   */
  onHideShowPage(type, id, e) {
    e.preventDefault();
    // Get current tab page detais
    let fields = this.state.currentTabPageDetails;
    fields['pageHide'] = type === 'hide';
    fields['updated_at'] = new Date();
    fields['users_userid'] = this.props.user.userUid;
    fields['users_username'] = this.props.user.username;
    fields['users_firstname'] = this.props.user.firstname;
    fields['users_lastname'] = this.props.user.surname;
    this.setState({
      tabId: id,
      editTitle: '',
      pageHiding: type === 'hide',
      pageShowing: type === 'show',
      pageHidingId: fields['pageUid'],
    });
    this.props.updatePage({
      token: this.props.token,
      data: { pageData: fields },
    });
  }

  /**
   * Function is used to set page visible date.
   * pag will be visible on selected date to people
   * On date change update the page details
   * @param {*} date selected date
   * @param {*} name field name
   * @param {*} id  pageUid
   */
  handleDateChange(dateObj, id) {
    // Get current tab page detais
    let pageDetails = this.state.currentTabPageDetails;
    let fields = pageDetails;
    fields['publish_start'] = new Date(dateObj.startDate);
    fields['publish_end'] = new Date(dateObj.endDate);
    fields['updated_at'] = new Date();
    fields['users_userid'] = this.props.user.userUid;
    fields['users_username'] = this.props.user.username;
    fields['users_firstname'] = this.props.user.firstname;
    fields['users_lastname'] = this.props.user.surname;
    this.setState({
      tabId: id,
      editTitle: '',
      publishDateUpdateData: true,
    });
    this.props.updatePage({
      token: this.props.token,
      data: { pageData: fields },
    });
  }

  /**
   * Function to initiate delete page confirmation dialog
   * @param pageUid page unique ID
   * @param e event
   * */
  initiateOnDeletePage(pageUid, e) {
    e.preventDefault();
    if (pageUid) {
      this.setState({
        deletePageModalData: {
          show: true,
          data: {
            heading: 'Delete page',
            body: 'Are you sure you want to delete this page?',
            rowId: pageUid,
          },
        },
      });
    }
  }

  /**
   * Function to delete page
   * page will be deleted for everyone except admin
   * @param pageUid page unique ID passed from state
   * */
  handleDeletePage(pageUid) {
    let fields = { ...this.state.currentTabPageDetails };
    fields['updated_at'] = new Date();
    fields['is_deleted'] = true;
    fields['navigation'] = false;
    fields['users_userid'] = this.props.user.userUid;
    fields['users_username'] = this.props.user.username;
    fields['users_firstname'] = this.props.user.firstname;
    fields['users_lastname'] = this.props.user.surname;
    this.setState({
      tabId: pageUid,
      editTitle: '',
      deletingPage: true,
    });
    this.props.updatePage({
      token: this.props.token,
      data: { pageData: fields },
    });
    this.setState({
      deletePageModalData: {
        show: false,
      },
    });
  }

  onAddBlog(e) {
    e.preventDefault();
    this.setState({
      addBlogEnabled: true,
    });
  }

  /**
   * Summary. Function used to find image tag and src attribute from content_html.
   * @param {*} str  content html string
   * @param {*} node tage (img)
   * @param {*} attr attriubte (src)
   */
  getAttrFromString(str, node, attr, style) {
    // let regex = new RegExp('<' + node + ' .*?' + attr + '="(.*?)" />', "gi"),
    //   result, res = [];
    let regex = new RegExp(`<${node} .*?${attr}="(.*?)" .*?>`, 'gi'),
      result,
      res = [];
    if (style) {
      regex = new RegExp(
        '<' + node + ' .*?' + attr + '="(.*?)" ' + style + '="(.*?)" />',
        'gi'
      );
    }
    while ((result = regex.exec(str))) {
      var obj = {};
      obj['tag'] = result[0];
      obj['key'] = result[1];
      if (style) {
        obj['style'] = result[2];
      }
      res.push(obj);
    }
    return res;
  }

  /**
   * On create new page
   * @param {*} e
   */
  onCreatePage(pageType, e) {
    // Find out pagetypeUid based on pageType

    let pageTypeObj = _.find(this.props.pageTypes, function (o) {
      return o.pageType === pageType;
    });
    let title = 'NEW PAGE';
    let slug = 'new-page-' + new Date().getTime().toString();
    if (pageType === 'Documents') {
      title = 'New Files Pages';
      slug = 'new-files-pages-' + +new Date().getTime().toString();
    }

    e.preventDefault();
    let pageData = {
      title: title,
      slug: slug,
      navigation: true,
      landing_page: false,
      content_html: '',
      description: '',
      pagetype_pagetype: pageTypeObj['pageType'],
      pagetypeUid: pageTypeObj['pagetypeUid'],
      editors: this.state.place['editors'],
      place_place: this.state.place['place'],
      place_slug: this.state.place['slug'],
      placeUid: this.state.place['placeUid'],
      created_at: new Date(),
      updated_at: new Date(),
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
      sort_order: this.draggablePages.length,
    };
    this.setState({
      ...this.state,
      pageCreating: {
        ...this.state.pageCreating,
        adding: true,
        type: pageType,
      },
    });
    // create page
    this.props.savePage({
      token: this.props.token,
      params: '?update_sort_order=true&create_new_page=true',
      data: {
        pageData: pageData,
        sortData: this.state.pageNavs.map((page, index) => {
          return { pageUid: page.pageUid, sort_order: index };
        }),
      },
    });
  }

  /**
   * Get active tab's page details from page props
   * @param {*} id PaagUid
   */
  getCurrentPageDetails(id) {
    let pageDetails = _.find(this.props.pages, function (o) {
      return o.pageUid === id;
    });
    return pageDetails;
  }

  onSubmit(edit_type, e) {
    e.preventDefault();
    if (this.validateForm()) {
      let fields = this.state.editPageData;
      let content_string = this.state.editPageData['content_html'];

      if (content_string) {
        let imgres = this.getAttrFromString(
          this.state.editPageData['content_html'],
          'img',
          'src',
          'style'
        );
        imgres.map(async function (single) {
          let url = single.key;
          url = url.replace(config.url.media_bucket_url, '');
          url = url.split('?');
          // console.log(url);
          let key = url[0].split('/');
          content_string = content_string.replace(single.key, key[1]);
        });
        let res = this.getAttrFromString(
          this.state.editPageData['content_html'],
          'iframe',
          'src',
          ''
        );
        res.map(async function (single) {
          let url = single.key;
          if (url && url.includes('https://drive.google.com/')) {
            let driveId = utilService.getGoogleDriveUrlId(url);
            let fileType = 'list';
            if (url.includes('#grid')) {
              fileType = 'grid';
            }
            content_string = content_string.replace(
              url,
              'https://drive.google.com/a/plc.nsw.edu.au/embeddedfolderview?id=' +
              driveId +
              '#' +
              fileType
            );
          }
        });
      }

      fields['content_html'] = content_string;
      if (fields['google_drive_url']) {
        let drive_url = fields['google_drive_url'];

        // let driveId = drive_url.match(/[-\w]{25,}/);
        let driveId = utilService.getGoogleDriveUrlId(
          fields['google_drive_url']
        );
        drive_url =
          'https://drive.google.com/a/plc.nsw.edu.au/embeddedfolderview?id=' +
          driveId +
          '#' +
          fields['file_view_type'];
        fields['google_drive_url'] = drive_url;
      }
      fields['updated_at'] = new Date();
      fields['users_userid'] = this.props.user.userUid;
      fields['users_username'] = this.props.user.username;
      fields['users_firstname'] = this.props.user.firstname;
      fields['users_lastname'] = this.props.user.surname;
      this.setState({
        fields,
        tabId: this.state.currentTabPageDetails.pageUid,
        editTitle: '',
        editing: edit_type,
        isLoading: true,
        isSaving: true,
      });

      console.log(this.state.editPageData);
      this.props.updatePage({
        token: this.props.token,
        data: { pageData: this.state.editPageData },
      });
    }
  }

  changeStaticPageTab(staticPageUid) {
    this.setState({ tabId: staticPageUid })
  }

  render() {
    const { units, classrooms } = this.props;
    const sortedUnitsByStartDate = sortUnitsByStartDate(units);
    let dragDisabledPagesList = this.dragDisabledPages && this.dragDisabledPages.length > 0 ? this.dragDisabledPages : []
    let pageNavsList = this.state.pageNavs && this.state.pageNavs.length > 0 ? this.state.pageNavs : []
    dataList = [...dragDisabledPagesList, ...pageNavsList]

    return (
      <div>
        <BackStrip nav={this.state.backUrl} isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header
              cname="admin-home"
              text={this.state.placeTitle}
              scriptTitle={true}
            />
            <main className="blurb pt-7">
              {this.props.pageActionLoading === true && (
                <utilService.GridSweetLoader
                  loading={this.props.pageActionLoading}
                />
              )}
              <Container fluid>
                <Row className="pt-5">
                  {this.state.isResize ?
                    <select
                      className={`mb-3 mt-3 form-control w-100`}
                      style={{ backgroundColor: "#f2f2f2", fontWeight: "600" }}
                      onChange={(e) => this.changeStaticPageTab(e.target.value)}
                      value={this.state.tabId}
                    >
                      {dataList.length
                        ? dataList.map((page) => {
                          const matchActiveTab =
                            (page['landing_page'] &&
                              this.state.tabId === 'default') ||
                            this.state.tabId === page.pageUid;
                          return (
                            <option value={page.pageUid}>
                              {page[this.fieldNames.title.name]}
                            </option>
                          );
                        })
                        : null}
                    </select> :
                    <Col xl={2} lg={3} className="pt-7">
                      <ul
                        className="nav main-nav nav-pills d-flex justify-content-center vertical-nav"
                        role="tablist"
                      >
                        {this.dragDisabledPages.length && this.state.place.klaUid && this.state.place.key_learning_area
                          ? this.dragDisabledPages.map((page) => {
                            const matchActiveTab =
                              (page['landing_page'] &&
                                this.state.tabId === 'default') ||
                              this.state.tabId === page.pageUid;
                            return (
                              <li key={page.pageUid} className="nav-item">
                                <a
                                  className={cx('nav-link', {
                                    active: matchActiveTab,
                                  })}
                                  data-toggle="pill"
                                  href={'#' + page['slug']}
                                  onClick={this.activeTabIndex.bind(
                                    this,
                                    page.pageUid
                                  )}
                                >
                                  {page[this.fieldNames.title.name]}
                                </a>
                              </li>
                            );
                          })
                          : null}
                      </ul>
                      <DragDropContext onDragEnd={this.handlePageNavDragEnd}>
                        <Droppable droppableId="pageList">
                          {(provided) => (
                            <ul
                              className="nav main-nav nav-pills d-flex justify-content-center vertical-nav"
                              ref={provided.innerRef}
                              role="tablist"
                              {...provided.droppableProps}
                            >
                              {/*pages tab */}

                              {this.state.pageNavs.length
                                ? this.state.pageNavs.map((item, index) => {
                                  const matchActiveTab =
                                    (item['landing_page'] &&
                                      this.state.tabId === 'default') ||
                                    this.state.tabId === item.pageUid;
                                  return (
                                    <Draggable
                                      key={item.pageUid}
                                      draggableId={item.pageUid}
                                      isDragDisabled={
                                        this.props.pageActionLoading ||
                                        !this.state.editIconEnable
                                      }
                                      index={index}
                                    >
                                      {(provided) => (
                                        <li
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          className="nav-item"
                                        >
                                          <a
                                            className={cx('nav-link', {
                                              active: matchActiveTab,
                                            })}
                                            data-toggle="pill"
                                            href={'#' + item['slug']}
                                            onClick={this.activeTabIndex.bind(
                                              this,
                                              item.pageUid
                                            )}
                                          >
                                            {item[this.fieldNames.title.name]}
                                          </a>
                                        </li>
                                      )}
                                    </Draggable>
                                  );
                                })
                                : null}
                              {/* Add new static and file page tab */}
                              {provided.placeholder}
                            </ul>
                          )}
                        </Droppable>
                      </DragDropContext>
                      <ul
                        className="nav main-nav nav-pills d-flex justify-content-center vertical-nav"
                        role="tablist"
                      >
                        {/* Add new static and file page tab */}
                        {this.state.editIconEnable
                          ? this.staticPages.map((item, index) => {
                            const matchActiveTab =
                              (item['landing_page'] &&
                                this.state.tabId === 'default') ||
                              this.state.tabId === item.pageUid;
                            return (
                              <li className="nav-item" key={item.pageUid}>
                                <a
                                  className={cx('nav-link', {
                                    active: matchActiveTab,
                                  })}
                                  data-toggle="pill"
                                  href={'#' + item['slug']}
                                  onClick={this.onCreatePage.bind(
                                    this,
                                    item.pageType
                                  )}
                                >
                                  {this.state.pageCreating['adding'] &&
                                    this.state.pageCreating['type'] ===
                                    item.pageType
                                    ? item['buttonName'] + '...'
                                    : item['buttonName']}
                                </a>
                              </li>
                            );
                          })
                          : null}
                      </ul>
                    </Col>}
                  <Col xl={9} lg={8} className="pt-7">
                    <div className="tab-content vertical-nav-tab-section">
                      {this.filteredPages.length
                        ? this.filteredPages.map((item, pageIndex) => {
                          const matchActiveTab =
                            (item['landing_page'] &&
                              this.state.tabId === 'default') ||
                            this.state.tabId === item.pageUid;

                          return (
                            <React.Fragment key={item.pageUid}>
                              {!item['landing_page'] &&
                                this.state.tabId !== 'default' &&
                                this.state.tabId === item.pageUid &&
                                item['pagetype_pagetype'] !== 'Task Page' &&
                                item['pagetype_pagetype'] !==
                                'Classrooms Page' &&
                                this.state.editIconEnable && (
                                  <div className="d-flex align-items-center justify-content-end border-bottom pb-3 mb-4">
                                    <div className="d-flex align-items-center justify-content-end flex-wrap">
                                      <div className="mr-3 d-flex align-items-center">
                                        <label
                                          htmlFor="publishedDatePicker"
                                          className="mr-2 text-right"
                                        >
                                          {item.publish_start
                                            ? (item.publish_start
                                              ? moment(
                                                item.publish_start
                                              ).format(
                                                'MMMM D, YYYY HH:mm'
                                              )
                                              : '') +
                                            ' to ' +
                                            (item.publish_end
                                              ? moment(
                                                item.publish_end
                                              ).format(
                                                'MMMM D, YYYY HH:mm'
                                              )
                                              : '')
                                            : 'Select publish period'}
                                        </label>
                                        <DateRangePicker
                                          initialSettings={{
                                            timePicker: true,
                                            timePickerIncrement: 30,
                                            timePicker24Hour: true,
                                            startDate: item.publish_start
                                              ? new Date(item.publish_start)
                                              : new Date(),
                                            endDate: item.publish_end
                                              ? new Date(item.publish_end)
                                              : new Date(),
                                            opens: 'left',
                                          }}
                                          onApply={(event, picker) =>
                                            this.handleDateChange(
                                              picker,
                                              item.pageUid
                                            )
                                          }
                                        >
                                          <button
                                            id="publishedDatePicker"
                                            type="button"
                                            className="btn h2 p-2 btn-icon"
                                          >
                                            <i className="fa fa-calendar" />
                                          </button>
                                        </DateRangePicker>
                                      </div>
                                    </div>
                                    {(item.pagetype_pagetype ===
                                      'Static Page' ||
                                      item.pagetype_pagetype ===
                                      'Documents') && (
                                        <React.Fragment>
                                          <button
                                            className="btn h2 p-2 btn-icon mr-3"
                                            onClick={this.onHideShowPage.bind(
                                              this,
                                              item.pageHide ? 'show' : 'hide',
                                              item.pageUid
                                            )}
                                          >
                                            {item.pageHide &&
                                              this.state.pageHiding === true &&
                                              this.state.pageHidingId !==
                                              item.pageUid && (
                                                <i className="fa fa-eye-slash" />
                                              )}
                                            {item.pageHide &&
                                              this.state.pageHiding ===
                                              false && (
                                                <i className="fa fa-eye-slash" />
                                              )}
                                            {!item.pageHide &&
                                              this.state.pageShowing === true &&
                                              this.state.pageHidingId ===
                                              item.pageUid && (
                                                <i className="fa fa-eye-slash" />
                                              )}
                                            {!item.pageHide &&
                                              this.state.pageShowing === true &&
                                              this.state.pageHidingId !==
                                              item.pageUid && (
                                                <i className="fa fa-eye" />
                                              )}
                                            {!item.pageHide &&
                                              this.state.pageShowing ===
                                              false && (
                                                <i className="fa fa-eye" />
                                              )}
                                            {item.pageHide &&
                                              this.state.pageHiding === true &&
                                              this.state.pageHidingId ===
                                              item.pageUid && (
                                                <i className="fa fa-eye" />
                                              )}
                                          </button>
                                          <button
                                            className="btn h2 p-2 btn-icon"
                                            onClick={this.initiateOnDeletePage.bind(
                                              this,
                                              item.pageUid
                                            )}
                                          >
                                            <i
                                              className="fa fa-trash"
                                              aria-hidden="true"
                                            />
                                          </button>
                                        </React.Fragment>
                                      )}
                                  </div>
                                )}
                              <div
                                id={item['slug']}
                                className={cx('tab-pane', {
                                  active: matchActiveTab,
                                  fade: !matchActiveTab,
                                })}
                                key={item.pageUid}
                              >
                                <div className="title-edit-wrap">
                                  {this.state.editTitle !==
                                    this.fieldNames.title.name && (
                                      <div className="content-edit-block">
                                        <h1>
                                          {item.pagetype_pagetype !==
                                            'Task Page' &&
                                            item.pagetype_pagetype !==
                                            'Classrooms Page'
                                            ? item[this.fieldNames.title.name]
                                            : item.pageTitle}
                                        </h1>
                                        {this.state.editIconEnable &&
                                          item.pagetype_pagetype !==
                                          'Task Page' &&
                                          item.pagetype_pagetype !==
                                          'Classrooms Page' && (
                                            <button
                                              type="button"
                                              onClick={this.clickonEditIcon.bind(
                                                this,
                                                this.fieldNames.title.name
                                              )}
                                              className="bg-dark filter-btn width-btn flex-shrink-0"
                                            >
                                              <i
                                                className="fa fa-pencil"
                                                aria-hidden="true"
                                              />
                                            </button>
                                          )}
                                      </div>
                                    )}
                                  {this.state.editTitle ===
                                    this.fieldNames.title.name && (
                                      <div className="title-input content-edit-form">
                                        <form>
                                          <div className="d-flex">
                                            <input
                                              type="text"
                                              name={this.fieldNames.title.name}
                                              placeholder="Edit Title"
                                              onChange={this.handleInputChange}
                                              value={
                                                this.state.editPageData[
                                                this.fieldNames.title.name
                                                ] || ''
                                              }
                                            />
                                            <div className="flex-shrink-0">
                                              <button
                                                className="form-btn"
                                                type="button"
                                                onClick={this.onSubmit.bind(
                                                  this,
                                                  this.fieldNames.title.name
                                                )}
                                              >
                                                {this.state.editing !==
                                                  this.fieldNames.title.name
                                                  ? 'Submit'
                                                  : 'Submit...'}
                                              </button>
                                              <button
                                                className="form-btn"
                                                type="button"
                                                onClick={this.onCancel.bind(
                                                  this
                                                )}
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                          <div className="errorMsg">
                                            {
                                              this.state.errors[
                                              this.fieldNames.title.errorKey
                                              ]
                                            }
                                          </div>
                                        </form>
                                      </div>
                                    )}
                                </div>
                                {item['pagetype_pagetype'] ===
                                  'Task Page' && this.state.place.place_id && (
                                    <AssessmentTasks
                                      placeID={this.state.place.place_id}
                                    />
                                  )}
                                {item['pagetype_pagetype'] ===
                                  'Classrooms Page' && (
                                    <Row>
                                      {classrooms.map(
                                        ({
                                          classroom_urlUid,
                                          class_name,
                                          alternateLink,
                                        }) => {
                                          return (
                                            <Col
                                              lg={2}
                                              md={4}
                                              xs={12}
                                              className="mb-4"
                                              key={classroom_urlUid}
                                            >
                                              <a
                                                href={alternateLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="d-flex flex-column h-100 p-3 bg-light course-unit"
                                              >
                                                <img
                                                  className="mb-3"
                                                  src={
                                                    '/assets/img/classrooms.png'
                                                  }
                                                  alt={class_name}
                                                />
                                                <h2 className="text-center mb-3">
                                                  {class_name}**
                                                </h2>
                                              </a>
                                            </Col>
                                          );
                                        }
                                      )}
                                    </Row>
                                  )}
                                {item['pagetype_pagetype'] === 'Blog Page' &&
                                  !this.state.addBlogEnabled &&
                                  this.state.editIconEnable && (
                                    <div className="d-flex align-items-center justify-content-end">
                                      <button
                                        type="button"
                                        className="ml-0 btn d-flex align-items-center p-0 border-0 bg-light rounded"
                                        onClick={this.onAddBlog.bind(this)}
                                      >
                                        <span className="h4 px-3">
                                          Add new blog
                                        </span>
                                        <i
                                          className="fa fa-plus filter-btn width-btn d-flex align-items-center justify-content-center bg-dark ml-0 rounded-left-0"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                    // <div class="d-flex align-items-center justify-content-end">
                                    //   <label>Add new blog</label>
                                    //   <button
                                    //     type="button"
                                    //     class="bg-dark filter-btn width-btn ml-3"

                                    //   >
                                    //     <i
                                    //       class="fa fa-plus"
                                    //       aria-hidden="true"
                                    //     />
                                    //   </button>
                                    // </div>
                                  )}
                                {/* {this.state.addBlogEnabled &&
                                  item['pagetype_pagetype'] ===
                                  'Blog Page' && (
                                    // <AddBlog />
                                    <CreatePost
                                      postId={''}
                                      notifyOnSubmit={this.handleFormSaved}
                                      componentName={'Pages'}
                                    />
                                  )} */}
                                <div className="content-wrapp">
                                  {item.pagetype_pagetype ===
                                    'Static Page' && (
                                      <div>
                                        {this.state.editTitle !== 'content' && (
                                          <div className="content-edit-block">
                                            <ContentHTML
                                              htmlContent={
                                                item[
                                                this.fieldNames.contentHtml
                                                  .name
                                                ]
                                              }
                                            />
                                            {this.state.editIconEnable && (
                                              <button
                                                type="button"
                                                onClick={this.clickonEditIcon.bind(
                                                  this,
                                                  'content'
                                                )}
                                                className="bg-dark filter-btn width-btn flex-shrink-0"
                                              >
                                                <i
                                                  className="fa fa-pencil"
                                                  aria-hidden="true"
                                                />
                                              </button>
                                            )}
                                          </div>
                                        )}
                                        {/* {item[this.fieldNames.contentHtml.name] ===
                                      '' && (
                                      <div className="errorMsg">
                                        {
                                          this.state.errors[
                                            this.fieldNames.contentHtml.name
                                          ]
                                        }
                                      </div>
                                    )} */}
                                        {this.state.editTitle === 'content' && (
                                          <div className="title-input content-edit-form ">
                                            <CKEditor
                                              onBeforeLoad={(CKEDITOR) => {
                                                if (this.CKE !== null) {
                                                  return false;
                                                }
                                                this.CKE = CKEDITOR;
                                                CKEDITOR.disableAutoInline = true;
                                                CKEDITOR.addCss(
                                                  'body.cke_editable { font-family: "Open Sans";font-size: 16px;line-height: 1.6;color: #586667;background-color: #ffffff;}p {color: #000;font-family: "Open Sans";font-size: 16px;}a {color: #C41425;text-decoration: none;}h1, h2, h3, h4, h5, h6, li  {color: #000}'
                                                );
                                                CKEDITOR.on(
                                                  'dialogDefinition',
                                                  function (ev) {
                                                    // Take the dialog window name and its definition from the event data.
                                                    const dialogName =
                                                      ev.data.name;

                                                    // debugger;
                                                    if (
                                                      dialogName === 'iframe'
                                                    ) {
                                                      const dialogDefinition =
                                                        ev.data.definition;
                                                      let fileViewType = 'list';
                                                      // const dialog =
                                                      //   ev.data.definition.dialog;
                                                      // console.log(
                                                      //   dialog.on(function (d) {
                                                      //     console.log(
                                                      //       'd.........',
                                                      //       d
                                                      //     );
                                                      //   })
                                                      // );
                                                      const infoTab = dialogDefinition.getContents(
                                                        'info'
                                                      );
                                                      dialogDefinition.minHeight = 150;

                                                      const widthField = infoTab.get(
                                                        'width'
                                                      );
                                                      widthField['default'] =
                                                        '100%';
                                                      const dNoneStyle =
                                                        'display: none';
                                                      widthField[
                                                        'style'
                                                      ] = dNoneStyle;
                                                      const heightField = infoTab.get(
                                                        'height'
                                                      );
                                                      heightField['default'] =
                                                        '180';
                                                      heightField[
                                                        'style'
                                                      ] = dNoneStyle;
                                                      const scrollingField = infoTab.get(
                                                        'scrolling'
                                                      );
                                                      scrollingField[
                                                        'default'
                                                      ] = true;
                                                      scrollingField[
                                                        'style'
                                                      ] = dNoneStyle;
                                                      const frameborderField = infoTab.get(
                                                        'frameborder'
                                                      );
                                                      frameborderField[
                                                        'default'
                                                      ] = 1;
                                                      frameborderField[
                                                        'style'
                                                      ] = dNoneStyle;
                                                      /*const urlField = infoTab.get(
                                                                                                                                                                                                          'src'
                                                                                                                                                                                                        );*/
                                                      var dialog =
                                                        ev.data.definition
                                                          .dialog;
                                                      dialog.on(
                                                        'show',
                                                        function () {
                                                          var txtUrlField = this.getContentElement(
                                                            'info',
                                                            'src'
                                                          );
                                                        }
                                                      );
                                                      infoTab.remove(
                                                        'fileView'
                                                      );
                                                      infoTab.remove('align');
                                                      // infoTab.remove('scrolling');
                                                      // infoTab.remove('frameborder');
                                                      infoTab.remove('name');
                                                      infoTab.remove('title');
                                                      infoTab.remove(
                                                        'longdesc'
                                                      );
                                                      infoTab.add({
                                                        type: 'hbox',
                                                        widths: ['50%', '50%'],
                                                        children: [
                                                          {
                                                            type: 'radio',
                                                            id: 'fileView',
                                                            label:
                                                              'Preferred file view',
                                                            items: [
                                                              [
                                                                'List View',
                                                                'list',
                                                              ],
                                                              [
                                                                'Grid View',
                                                                'grid',
                                                              ],
                                                            ],
                                                            setup: function () {
                                                              const url = this.getDialog().getValueOf(
                                                                'info',
                                                                'src'
                                                              );
                                                              if (
                                                                url.includes(
                                                                  '#grid'
                                                                )
                                                              ) {
                                                                this.setValue(
                                                                  'grid'
                                                                );
                                                              }
                                                            },
                                                            onChange: function () {
                                                              var dialog = this.getDialog();
                                                              this.iframeFileView = dialog.getValueOf(
                                                                'info',
                                                                'fileView'
                                                              );
                                                            },
                                                            default: fileViewType,
                                                          },
                                                        ],
                                                      });
                                                      dialog.on(
                                                        'ok',
                                                        function () {
                                                          let url = this.getContentElement(
                                                            'info',
                                                            'src'
                                                          ).getValue();
                                                          let fileView = this.getContentElement(
                                                            'info',
                                                            'fileView'
                                                          ).getValue();

                                                          if (
                                                            !url.includes(
                                                              '#grid'
                                                            ) &&
                                                            !url.includes(
                                                              '#list'
                                                            )
                                                          ) {
                                                            this.getContentElement(
                                                              'info',
                                                              'src'
                                                            ).setValue(
                                                              url +
                                                              '#' +
                                                              fileView
                                                            );
                                                          }
                                                          if (
                                                            fileView ===
                                                            'list' &&
                                                            url.includes(
                                                              '#grid'
                                                            )
                                                          ) {
                                                            this.getContentElement(
                                                              'info',
                                                              'src'
                                                            ).setValue(
                                                              url.replace(
                                                                '#grid',
                                                                '#list'
                                                              )
                                                            );
                                                          }
                                                          if (
                                                            fileView ===
                                                            'grid' &&
                                                            url.includes(
                                                              '#list'
                                                            )
                                                          ) {
                                                            this.getContentElement(
                                                              'info',
                                                              'src'
                                                            ).setValue(
                                                              url.replace(
                                                                '#list',
                                                                '#grid'
                                                              )
                                                            );
                                                          }
                                                        }
                                                      );
                                                    }
                                                  }
                                                );
                                              }}
                                              config={{
                                                startupFocus: true,
                                                stylesSet: [
                                                  // Block-level styles.
                                                  {
                                                    name: 'Content title',
                                                    element: 'h1',
                                                    styles: {
                                                      color: '#C41425',
                                                      'font-family':
                                                        'Open Sans Semibold',
                                                      'line-height': '135%',
                                                    },
                                                  },
                                                  {
                                                    name: 'Content Info',
                                                    element: 'p',
                                                    styles: {
                                                      color: '#586667',
                                                      padding: '0px !important',
                                                      'font-family':
                                                        'Open Sans Light',
                                                      'font-size': '14px',
                                                    },
                                                  },
                                                  // Inline styles.
                                                  {
                                                    name: 'Text Gray',
                                                    element: 'p',
                                                    styles: {
                                                      color: '#AAA !important',
                                                      'font-family':
                                                        'Open Sans Light',
                                                      'font-size': '16px',
                                                    },
                                                  },
                                                  {
                                                    name: 'Anchor Red',
                                                    element: 'a',
                                                    styles: {
                                                      color:
                                                        '#C41425 !important',
                                                      'text-decoration': 'none',
                                                    },
                                                  },
                                                ],
                                                format_tags:
                                                  'p;h1;h2;h3;h4;h5;h6;pre;address;div',
                                                extraPlugins:
                                                  'embed,autoembed,iframe',

                                                filebrowserUploadUrl:
                                                  config.api_url +
                                                  config.url
                                                    .upload_editor_image,
                                                embed_provider:
                                                  '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
                                              }}
                                              onFileUploadRequest={
                                                this.onFileUploadReq
                                              }
                                              onFileUploadResponse={
                                                this.onFileUploadRes
                                              }
                                              onChange={this.onEditorChange}
                                              data={
                                                this.state.editPageData[
                                                this.fieldNames.contentHtml
                                                  .name
                                                ] || ''
                                              }
                                            />
                                            {/* <div className="errorMsg">
                                          {
                                            this.state.errors[
                                              this.fieldNames.contentHtml.name
                                            ]
                                          }
                                        </div> */}
                                            <button
                                              className="form-btn ml-0"
                                              type="button"
                                              onClick={this.onSubmit.bind(
                                                this,
                                                'content'
                                              )}
                                            >
                                              Submit
                                            </button>
                                            <button
                                              className="form-btn"
                                              type="button"
                                              onClick={this.onCancel.bind(this)}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  {item.pagetype_pagetype ===
                                    this.fileRepoPageTypeName && (
                                      <div>
                                        {this.state.editTitle !==
                                          this.fileRepoPageTypeName && (
                                            <div className="border">
                                              <div className="d-flex align-items-center p-4">
                                                <h3>Document Repository</h3>
                                                {this.state.editIconEnable && (
                                                  <div className="d-flex flex-shrink-0 ml-auto">
                                                    <button
                                                      type="button"
                                                      onClick={this.clickonEditIcon.bind(
                                                        this,
                                                        this.fileRepoPageTypeName
                                                      )}
                                                      className="bg-dark filter-btn width-btn"
                                                    >
                                                      <i
                                                        className="fa fa-pencil"
                                                        aria-hidden="true"
                                                      />
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="bg-primary filter-btn width-btn"
                                                      onClick={this.initiateDeleteFolderID.bind(
                                                        this,
                                                        item.pageUid
                                                      )}
                                                    >
                                                      <i
                                                        className="fa fa-trash"
                                                        aria-hidden="true"
                                                      />
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                              {item[
                                                this.fieldNames.googleFolderID
                                                  .name
                                              ] !== '' ? (
                                                <iframe
                                                  src={
                                                    item[
                                                    this.fieldNames
                                                      .googleFolderID.name
                                                    ]
                                                  }
                                                  className="border-0"
                                                  scrolling="yes"
                                                  frameBorder="1"
                                                  height={600}
                                                  width="100%"
                                                  title="File repo"
                                                />
                                              ) : (
                                                <p className="px-4 mb-4">
                                                  Please enter Google Drive url
                                                </p>
                                              )}
                                            </div>
                                          )}
                                        {this.state.editTitle ===
                                          this.fileRepoPageTypeName && (
                                            <div className="content-edit-form">
                                              <form>
                                                <div className="d-flex align-items-center mb-4">
                                                  <label className="title-label">
                                                    Google Drive url
                                                  </label>
                                                  <input
                                                    type="text"
                                                    name={
                                                      this.fieldNames
                                                        .googleFolderID.name
                                                    }
                                                    placeholder="Enter Google Drive Url"
                                                    onChange={
                                                      this.handleInputChange
                                                    }
                                                    value={
                                                      this.state.editPageData[
                                                      this.fieldNames
                                                        .googleFolderID.name
                                                      ] || ''
                                                    }
                                                  />
                                                </div>
                                                <label className="title-label d-block mb-3">
                                                  Preferred file view
                                                </label>
                                                <div className="d-flex">
                                                  <label className="typeradio mr-4">
                                                    List
                                                    <input
                                                      type="radio"
                                                      name={
                                                        this.fieldNames
                                                          .googleFolderID.type
                                                      }
                                                      onChange={
                                                        this.handleInputChange
                                                      }
                                                      checked={
                                                        this.state.editPageData[
                                                        this.fieldNames
                                                          .googleFolderID.type
                                                        ] === 'list'
                                                      }
                                                      value="list"
                                                    />
                                                    <span className="radiomark" />
                                                  </label>
                                                  <label className="typeradio">
                                                    Grid
                                                    <input
                                                      type="radio"
                                                      name={
                                                        this.fieldNames
                                                          .googleFolderID.type
                                                      }
                                                      onChange={
                                                        this.handleInputChange
                                                      }
                                                      checked={
                                                        this.state.editPageData[
                                                        this.fieldNames
                                                          .googleFolderID.type
                                                        ] === 'grid'
                                                      }
                                                      value="grid"
                                                    />
                                                    <span className="radiomark" />
                                                  </label>
                                                </div>
                                                <div className="flex-shrink-0">
                                                  <button
                                                    className="form-btn ml-0"
                                                    type="button"
                                                    onClick={this.onSubmit.bind(
                                                      this,
                                                      this.fieldNames
                                                        .googleFolderID.name
                                                    )}
                                                  >
                                                    {this.state.editing !==
                                                      this.fieldNames.googleFolderID
                                                        .name
                                                      ? 'Submit'
                                                      : 'Submit...'}
                                                  </button>
                                                  <button
                                                    className="form-btn"
                                                    type="button"
                                                    onClick={this.onCancel.bind(
                                                      this
                                                    )}
                                                  >
                                                    Cancel
                                                  </button>
                                                </div>
                                                {/* <div className="errorMsg">
                                            {
                                              this.state.errors[
                                                this.fieldNames.googleFolderID
                                                  .errorKey
                                              ]
                                            }
                                          </div> */}
                                              </form>
                                            </div>
                                          )}
                                      </div>
                                    )}
                                </div>
                                {sortedUnitsByStartDate.length &&
                                  item['landing_page'] ? (
                                  <Row>
                                    {sortedUnitsByStartDate.map((item, index) => {
                                      return (
                                        <Col
                                          lg={3}
                                          md={4}
                                          xs={12}
                                          className="mb-4"
                                          key={item.unit_id}
                                        >
                                          <div className="d-flex flex-column h-100 p-3 bg-light course-unit rounded-xs">
                                            <h2
                                              className="text-center mb-3"
                                              dangerouslySetInnerHTML={{
                                                __html: item.unit_name,
                                              }}
                                            />
                                            {/* Might need this code in the future <div className="d-flex align-items-center">
                                              <h4 className="mb-3 mr-3">
                                                Start date:{' '}
                                                {moment(UNIT_START_DATE).format(
                                                  'YYYY-MM-DD'
                                                )}
                                              </h4>
                                              <h4 className="mb-3 ml-auto">
                                                End date:{' '}
                                                {moment(UNIT_END_DATE).format(
                                                  'YYYY-MM-DD'
                                                )}
                                              </h4>
                                            </div> */}
                                            {item.component_html && item.component_html !== "None" &&
                                              <div
                                                id="test-1"
                                                onLoad={this.handleHTMLContent}
                                                className="flex-grow-1"
                                                dangerouslySetInnerHTML={{
                                                  __html: utilService.htmlDecode(
                                                    item.component_html
                                                  ),
                                                }}
                                              />
                                            }
                                          </div>
                                        </Col>
                                      );
                                    }
                                    )}
                                  </Row>
                                ) : null}
                              </div>
                            </React.Fragment>
                          );
                        })
                        : null}
                    </div>
                  </Col>
                </Row>
              </Container>
              <DialogBox
                show_modal={this.state.modal_data}
                hide_modal={this.handleCloseModal.bind(this)}
                onSubmit={this.handleDeleteFolderID.bind(this)}
              />
              <DialogBox
                show_modal={this.state.deletePageModalData}
                hide_modal={this.handleCloseModal.bind(this)}
                onSubmit={this.handleDeletePage.bind(this)}
              />
            </main>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 */
function mapStateToProps(state) {
  return {
    pageActionLoading: state.pages.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    places: Object.values(state.places.byId),
    pageTypes: Object.values(state.pagetypes.byId),
    pages: Object.values(state.pages.byId),
    units: Object.values(state.courseUnits.byId),
    classrooms: Object.values(state.courseClassrooms.byId),
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, pagesActions, adminActions), dispatch)
)(Pages);
